import { useMutation } from '@tanstack/react-query'

import { disqualifyRespondent } from 'services/glass-api/respondents'

export function useDisqualifyRespondent() {
  return useMutation({ mutationFn: disqualifyRespondent })
}
